export function apiBrandFromParam(brandParam) {
  const normalized = String(brandParam || '')
    .replace(/-/g, ' ')
    .toLowerCase()
    .trim()
  if (normalized === 'zara') return 'zara'
  return 'zarahome'
}

export function brandLabel(apiBrand) {
  return apiBrand === 'zara' ? 'Zara' : 'Zara Home'
}

export function isHomeBrand(apiBrand) {
  return apiBrand !== 'zara'
}

export function slugFromBrandName(name) {
  return String(name || '')
    .toLowerCase()
    .replace(/\s+/g, '-')
}

export const ZARA_JSON_FIELDS = ['uk', 'ita', 'usa', 'europe', 'mexico', 'brBrasil']

export const ZARA_SIZE_FIELDS = [
  { name: 'uid', label: 'UID', hint: 'Boş bırakılırsa otomatik üretilir. Eski sipariş eşlemesi için değiştirmeyin.' },
  { name: 'name', label: 'Grup adı', hint: 'Aynı isimdeki bedenler sipariş formunda border ile gruplanır.' },
  { name: 'sCode', label: 'sCode' },
  { name: 'scode', label: 'scode' },
  { name: 'size', label: 'Size' },
  { name: 'cn', label: 'CN' },
  { name: 'uk', label: 'UK' },
  { name: 'ita', label: 'ITA' },
  { name: 'europe', label: 'Europe' },
  { name: 'usa', label: 'USA' },
  { name: 'mexico', label: 'Mexico' },
  { name: 'brBrasil', label: 'BR Brasil' },
  { name: 'cm', label: 'CM' },
  { name: 'inches', label: 'Inches' },
  { name: 'gender', label: 'Gender' },
  { name: 'isMonth', label: 'isMonth' },
  { name: 'lowercn', label: 'Lower CN' },
  { name: 'cnupperwoman', label: 'CN Upper Woman' },
  { name: 'cnlowerwoman', label: 'CN Lower Woman' }
]

export const HOME_SIZE_FIELDS = [
  { name: 'name', label: 'Grup adı', hint: 'Aynı isimdeki bedenler sipariş formunda border ile gruplanır.' },
  { name: 'scode', label: 'scode' },
  { name: 'size', label: 'Size' },
  { name: 'cm', label: 'CM' },
  { name: 'inches', label: 'Inches' },
  { name: 'gender', label: 'Gender' },
  { name: 'cn', label: 'CN' },
  { name: 'europe', label: 'Europe' },
  { name: 'usa', label: 'USA' },
  { name: 'mexico', label: 'Mexico' },
  { name: 'br-brasil', label: 'BR Brasil' },
  { name: 'cnlower', label: 'CN Lower' },
  { name: 'cnupper', label: 'CN Upper' },
  { name: 'uid', label: 'UID (opsiyonel)' }
]

export const ZARA_TABLE_COLUMNS = [
  { key: 'name', label: 'Grup adı' },
  { key: 'sCode', label: 'sCode' },
  { key: 'scode', label: 'scode' },
  { key: 'size', label: 'Size' },
  { key: 'cn', label: 'CN' },
  { key: 'uk', label: 'UK' },
  { key: 'europe', label: 'Europe' },
  { key: 'usa', label: 'USA' },
  { key: 'cm', label: 'CM' },
  { key: 'gender', label: 'Gender' }
]

export const HOME_TABLE_COLUMNS = [
  { key: 'name', label: 'Grup adı' },
  { key: 'scode', label: 'scode' },
  { key: 'size', label: 'Size' },
  { key: 'cm', label: 'CM' },
  { key: 'inches', label: 'Inches' },
  { key: 'gender', label: 'Gender' },
  { key: 'cn', label: 'CN' },
  { key: 'europe', label: 'Europe' },
  { key: 'usa', label: 'USA' }
]

const HIDDEN_SIZE_KEYS = new Set([
  '_id',
  '_sortOrder',
  'id',
  'index',
  'sizeGroupId',
  'sizeGroupHomeId',
  'sortOrder',
  'createdAt',
  'updatedAt',
  'extras'
])

export function sizeFieldsFor(apiBrand) {
  return isHomeBrand(apiBrand) ? HOME_SIZE_FIELDS : ZARA_SIZE_FIELDS
}

export function tableColumnsFor(apiBrand) {
  return isHomeBrand(apiBrand) ? HOME_TABLE_COLUMNS : ZARA_TABLE_COLUMNS
}

export function toInputValue(value) {
  if (value == null) return ''
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

export function parseMaybeJson(value) {
  if (value == null || value === '') return null
  if (typeof value !== 'string') return value
  const trimmed = value.trim()
  if (
    (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
    (trimmed.startsWith('[') && trimmed.endsWith(']'))
  ) {
    try {
      return JSON.parse(trimmed)
    } catch {
      return value
    }
  }
  return value
}

export function extraEntriesFromSize(size, fields) {
  if (!size || typeof size !== 'object') return []
  const known = new Set(fields.map((field) => field.name))
  const entries = []
  for (const [key, value] of Object.entries(size)) {
    if (HIDDEN_SIZE_KEYS.has(key) || known.has(key)) continue
    entries.push({ key, value: toInputValue(value) })
  }
  return entries
}

export function sizeToFormValues(size, fields) {
  const values = {}
  for (const field of fields) {
    values[field.name] = toInputValue(size?.[field.name])
  }
  if (fields.some((field) => field.name === 'br-brasil') && !values['br-brasil']) {
    values['br-brasil'] = toInputValue(size?.brBrasil)
  }
  values.__extras = extraEntriesFromSize(size, fields)
  return values
}

export function formValuesToSizePayload(values, apiBrand) {
  const { __extras, ...rest } = values || {}
  const payload = {}
  const jsonFields = new Set(isHomeBrand(apiBrand) ? [] : ZARA_JSON_FIELDS)

  for (const [key, value] of Object.entries(rest)) {
    if (key.startsWith('_')) continue
    if (value === undefined) continue
    payload[key] = jsonFields.has(key) ? parseMaybeJson(value) : value === '' ? null : value
  }

  const extras = {}
  for (const item of __extras || []) {
    if (!item?.key) continue
    extras[item.key] = item.value === '' ? null : item.value
  }
  payload.extras = extras
  return payload
}

export function formatCell(value) {
  if (value == null || value === '') return '—'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

export function groupSizeCount(record) {
  if (typeof record?.sizeCount === 'number') return record.sizeCount
  if (Array.isArray(record?.sizes)) return record.sizes.length
  return 0
}
